(ns ycweb.app.website.cart.pages.details-instructions
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cart.parts.common :as cart.common]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as forms]
   [ycweb.components.buttons :as buttons]))

(rum/defc special-instructions-form < rum/reactive cmn/cursors
  {:init
   (fn [state _props]
     (let [[app-atom process-atom cart-summary-atom] (:rum/args state)]
       (swap! cart-summary-atom assoc :delivery
         (get-in @cart-summary-atom [:cart :delivery])))
     state)}
  [app-atom process-atom cart-atom]
  (let [instructions-atom (rum/cursor-in cart-atom [:delivery :specialinstructions])
        instructions (rum/react instructions-atom)

        char-limit 65
        char-count (count (or instructions ""))
        char-remaining (- char-limit char-count)

        update-instructions
        (fn []
          (swap! cart-atom assoc-in [:cart :delivery :specialinstructions] instructions))]

    (cart.common/checkout-layout process-atom true

      (list

        [:h2 {:key "instructions-heading" :class "yc-heading yc-heading--default"}
         "Would you like to leave instructions for our delivery team?"]
        [:p {:key "instructions-description" :class "yc-paragraph"}
         "Let us know here and we'll add it to the notes for your order."]

        [:div {:key "instructions-form" :class "form u-max-width-480 u-margin-bottom-30"}
         (forms/textarea "Delivery instructions:"
           instructions-atom
           {:hint (str char-remaining " characters remaining.")
            :limit char-limit
            :rows 4
            :name "metadata[comments]"
            :id "comments"})]

        [:div {:key "skip-button"}
         (buttons/button-web "Skip this step"
           {:on-click #(cart.common/skip-step app-atom process-atom cart-atom nil %)
            :disabled (pos? char-count)
            :style :secondary
            :icon-placement :right
            :class "button--has-icon-right"
            :icon :arrow-right})])

      (cart.common/checkout-cta-sidebar app-atom process-atom cart-atom
        {:disabled? (zero? char-count)
         :skip-disabled? (pos? char-count)
         :continue-fn update-instructions}))))

(defmethod cart.common/checkout-step :details/instructions
  [app-atom process-atom cart-summary-atom]
  (special-instructions-form app-atom process-atom cart-summary-atom))